import Vue from 'vue';
import Component from 'vue-class-component';

import ApprenticeCard from '../../../components/ApprenticeCard/ApprenticeCard.vue';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner.vue';
import APIService from '../../../services/APIService';
import ApprenticeResponse from '../../../models/responses/ApprenticeResponse';

/**
 * The Dashboard which shows all apprentices of a coach.
 */
@Component({
  name: 'CoachDashboardView',
  components: {
    ApprenticeCard,
    LoadingSpinner,
  },
})
export default class CoachDashboardView extends Vue {
  private apprentices: Array<ApprenticeResponse> = [];
  private loading = false;

  private get filteredApprentices() {
    if (!this.$route.query.search) return this.apprentices;

    return this.apprentices.filter((a) => {
      const name1 = `${a.firstName.toLowerCase()} ${a.lastName.toLowerCase()}`;
      const name2 = `${a.lastName.toLowerCase()} ${a.firstName.toLowerCase()}`;
      if (
        name1.includes(this.$route.query.search.toString().toLowerCase()) ||
        name2.includes(this.$route.query.search.toString().toLowerCase())
      )
        return a;
    });
  }

  /**
   * Fetches apprentice overview data from the backend.
   */
  async mounted() {
    this.loading = true;
    this.apprentices = await APIService.getApprentices();
    this.loading = false;
  }

  /**
   * Sets the search query in route and trigers the filter method
   *
   * @param val - search query
   */
  private async setSearchQuery(val: string) {
    if (!val) await this.$router.replace({ query: {} });
    else await this.$router.replace({ query: { search: val } });
  }
}
